<mat-toolbar>
    <span class="title">{{ title() }}</span>
    <span class="spacer"></span>
    <!-- Trailing actions are page-specific (add button, tooltip-or-not, multiple buttons). -->
    <ng-content></ng-content>
</mat-toolbar>
